import { isPlatformBrowser, isPlatformServer } from "@angular/common";
import { Inject, Injectable, LOCALE_ID, OnDestroy, PLATFORM_ID } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router  } from "@angular/router";
import { Subject } from "rxjs";
import { Observable } from 'rxjs/internal/Observable';
import { catchError, map, takeUntil } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { Ipo } from "../models/ipo";
import { CanonicalService } from "../services/canonical.service";
import { IpocalendarService } from "../services/ipocalendar.service";
import { JsonldService } from "../services/jsonld.service";
import { MetaSeoService } from "../services/meta-seo.service";
import { ErrorMsg } from "../utils/error-msg";

@Injectable({
    providedIn: 'root',
  })
  export class IpoDetailResolver implements Resolve<any> ,OnDestroy {
    destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(
      @Inject(LOCALE_ID) private localId: Object,
      @Inject(PLATFORM_ID) private platformId: Object,
      private canonicalService: CanonicalService,
      private ipoService:IpocalendarService,
      private seoService:MetaSeoService,
      public jsonldService: JsonldService,
      private router: Router,
    ){}

    ngOnDestroy(): void {
      this.destroy$.next(true);
      this.destroy$.unsubscribe();
    }

    resolve(route: ActivatedRouteSnapshot): Observable<any> {
      if (isPlatformBrowser(this.platformId) || isPlatformServer(this.platformId)) {
        const urlParam = route.paramMap.get('url');
        const subSuffex="/ipo-calendar/"
        const domain=environment.domain;
        const lang = String(this.localId).substring(0, 2);
        let domainAndLangURL = `${domain}/${lang}`;
        let canonicalURL = domainAndLangURL+subSuffex+urlParam;
        if (urlParam) {
          return  this.ipoService.getByUrl(urlParam).pipe(
            takeUntil(this.destroy$),
            map(a => {
              if (!a) {
                this.router.navigate([subSuffex]);
              }
              let ipo = a as Ipo;
              let titlePrefix = this.getTitle(ipo)
              a.title = titlePrefix;
              let title = `${titlePrefix} | Halka Arz Info`;
              let description = `${titlePrefix} IPO Detailed Information and Stock Comments`;
              if(lang == "tr"){
                description = `${titlePrefix} Halka Arz Detay Bilgileri ve Hisse Yorumları`;
              }
              let imageUrl=domainAndLangURL+"/"+urlParam+".webp"
              this.canonicalService.setCanonicalURLForId(canonicalURL);
              this.seoService.setMetaAndTitle(title,description,canonicalURL,domainAndLangURL,null,imageUrl);
              this.canonicalService.setOnlyAlternateDefault(canonicalURL);
              this.jsonldService.removeJsonSnippet();
              this.jsonldService.setOrganization();
              this.jsonldService.setBreadCrumbListItem(domain,lang,title,subSuffex)
              this.jsonldService.setWebSiteType(domain,lang);
              this.jsonldService.setTableType(title);
              return ipo;

            }),
            catchError(err => ErrorMsg.handleError(this.router,err))
            )
          }else{
            this.router.navigate([subSuffex]);
          }
        }
    }

  getTitle(ipo){
    let title = `${ipo.code} - ${ipo.name}`;
    if(ipo?.name == ipo?.code){
      title =`${ipo.name}`;
    } else if(ipo?.name?.toLowerCase().includes(ipo?.code?.toLowerCase())){
      title =`${ipo.name}`;
    }
    return title;
  }
}
